var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.STOCK_TRANSFER_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: false,
          "before-reset-search": _vm.beforeResetSearch,
          "before-query-search": _vm.beforeQuerySearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "移仓单号", prop: "code" } },
                      [
                        _c("BjInputCode", {
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "code", $$v)
                            },
                            expression: "queryParams.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("table.statusText"),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.isVerify
                              ? _vm.STOCK_ALLOT_STATUS.slice(0, 2)
                              : _vm.STOCK_ALLOT_STATUS,
                          },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "移入虚仓",
                          prop: "receiveWarehouseIdList",
                        },
                      },
                      [
                        _c("BjSelectWarehouse", {
                          attrs: {
                            "type-code": [
                              "default-virtual",
                              "qty-virtual",
                              "interline-virtual",
                            ],
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryParams.receiveWarehouseIdList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "receiveWarehouseIdList",
                                $$v
                              )
                            },
                            expression: "queryParams.receiveWarehouseIdList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "移出虚仓",
                          prop: "supportWarehouseIdList",
                        },
                      },
                      [
                        _c("BjSelectWarehouse", {
                          attrs: {
                            "type-code": [
                              "default-virtual",
                              "qty-virtual",
                              "interline-virtual",
                            ],
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryParams.supportWarehouseIdList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "supportWarehouseIdList",
                                $$v
                              )
                            },
                            expression: "queryParams.supportWarehouseIdList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("table.createTimeText") } },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t("table.createTimeText"),
                          },
                          model: {
                            value: _vm.queryParamsTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime = $$v
                            },
                            expression: "queryParamsTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    !_vm.isVerify
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessStockTransferVirtualAdd",
                                arg: "BusinessStockTransferVirtualAdd",
                              },
                            ],
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onAdd },
                          },
                          [_vm._v(_vm._s(_vm.$t("addText")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    _c("el-table-column", {
                      key:
                        "col_" +
                        index +
                        "_" +
                        col.prop +
                        "_" +
                        (col.width || "auto"),
                      attrs: {
                        prop: col.prop,
                        label: col.label,
                        width: col.width || "auto",
                        fixed: col.fixed || false,
                        align: "center",
                        "class-name": "item",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                false
                                  ? void 0
                                  : col.prop === "status"
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.STOCK_ALLOT_STATUS.bjGet(
                                              scope.row[col.prop]
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  : col.prop == "bjTableAction"
                                  ? [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: !_vm.isVerify
                                                ? "BusinessStockTransferVirtualView"
                                                : "BusinessStockVerifyVirtualView",
                                              expression:
                                                "\n                  !isVerify\n                    ? 'BusinessStockTransferVirtualView'\n                    : 'BusinessStockVerifyVirtualView'\n                ",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toView(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("viewText")))]
                                      ),
                                      !_vm.isVerify
                                        ? [
                                            scope.row.status == "wait"
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessStockTransferVirtualEdit",
                                                        arg: "BusinessStockTransferVirtualEdit",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "text",
                                                      text: "待审核状态下可修改，点击跳转编辑调拨表单，自动带入当前调拨信息",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onEdit(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("修改")]
                                                )
                                              : _vm._e(),
                                            ["fail", "cancel"].includes(
                                              scope.row.status
                                            )
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessStockTransferVirtualIndex_Reset",
                                                        arg: "BusinessStockTransferVirtualIndex_Reset",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "text",
                                                      text: "待审核状态下可取消，点击取消弹窗确认是否取消，确认取消后则取消所选调拨申请",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onStatus(
                                                          scope.row,
                                                          "resetDistributeVirtuals",
                                                          "重置"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("resetText")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            scope.row.status == "wait-execute"
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessStockTransferVirtualIndex_Execute1",
                                                        arg: "BusinessStockTransferVirtualIndex_Execute1",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "text",
                                                      text: "待执行状态下可执行",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onStatus(
                                                          scope.row,
                                                          "executeDistributeVirtuals",
                                                          "执行"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("执行")]
                                                )
                                              : _vm._e(),
                                            scope.row.status == "execute-fail"
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessStockTransferVirtualIndex_Execute2",
                                                        arg: "BusinessStockTransferVirtualIndex_Execute2",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "text",
                                                      text: "执行失败状态下可再次执行",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onStatus(
                                                          scope.row,
                                                          "executeDistributeVirtuals",
                                                          "再次执行"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("再次执行")]
                                                )
                                              : _vm._e(),
                                            scope.row.status == "wait"
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessStockTransferVirtualIndex_Cancel",
                                                        arg: "BusinessStockTransferVirtualIndex_Cancel",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "text",
                                                      text: "待审核状态下可取消，点击取消弹窗确认是否取消，确认取消后则取消所选调拨申请",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onStatus(
                                                          scope.row,
                                                          "cancelDistributeVirtuals",
                                                          "取消"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("cancelText")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            [
                                              "wait-execute",
                                              "execute-fail",
                                            ].includes(scope.row.status)
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessStockTransferVirtualIndex_Invalid",
                                                        arg: "BusinessStockTransferVirtualIndex_Invalid",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "text",
                                                      text: "待执行和执行失败下可作废，作废后该移仓无需执行",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onStatus(
                                                          scope.row,
                                                          "invalidDistributeVirtuals",
                                                          "作废"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("作废")]
                                                )
                                              : _vm._e(),
                                          ]
                                        : [
                                            scope.row.status == "wait"
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessStockVerifyVirtualIndex_Pass",
                                                        arg: "BusinessStockVerifyVirtualIndex_Pass",
                                                      },
                                                    ],
                                                    staticClass: "main-btn",
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onAudit(
                                                          "pass",
                                                          scope.row.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("审核通过")]
                                                )
                                              : _vm._e(),
                                            scope.row.status == "wait"
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessStockVerifyVirtualIndex_Reject",
                                                        arg: "BusinessStockVerifyVirtualIndex_Reject",
                                                      },
                                                    ],
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onAudit(
                                                          "reject",
                                                          scope.row.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("审核拒绝")]
                                                )
                                              : _vm._e(),
                                          ],
                                    ]
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("timeFilters")(
                                            scope.row[col.prop],
                                            scope.row[col.prop]
                                          )
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }